<template>
  <ExternalQueryList
      endpoint="/api/v2/memberships"
      :headlines="headlines"
      :filters="filters"
      :can-update="() => true"
      @show="membership => $router.push('/people/'+membership.attributes.person_id)"
  >
    <template v-slot:default="{ row: membership }">
      <td class="table__ellipsis">
        <router-link :to="'/people/'+membership.attributes.person_id">
          {{ membership.attributes.person_name }}
        </router-link>
      </td>

      <td class="table__ellipsis">
        <router-link :to="'/portals/' + membership.attributes.portal_id">
          {{ membership.attributes.portal_name }}
        </router-link>
      </td>

      <td class="table__ellipsis">
        {{ membership.attributes.membership_type_name }}
      </td>

      <td class="table__ellipsis">
        {{ membership.attributes.price | price }}
      </td>

      <td class="table__ellipsis">
        <StatusLabel :status="membership.attributes.status"/>
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'
import StatusLabel from '../../../StatusLabel'

export default {
  components: { ExternalQueryList, StatusLabel},

  props: {
    users: {
      required: true
    },

    portals: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 6, text: 'Subscriber'},
        {width: 3, text: 'Portal'},
        {width: 3, text: 'Type'},
        {width: 4, text: 'Price'},
        {width: 4, text: 'Status'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 10,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 5,
            widget: 'select',
            name: 'has_automatic_renewal',
            options: [
              {value: 0, label: 'Without Automatic Renewal'},
              {value: 1, label: 'With Automatic Renewal'}
            ],
            nullable: true,
            placeholder: 'Choose Automatic Renewal...'
          },
          {
            width: 5,
            widget: 'select',
            name: 'status',
            options: [
              {value: 'active', label: 'Active'},
              {value: 'expired', label: 'Expired'}
            ],
            nullable: true,
            placeholder: 'Choose Status...'
          },
          {
            width: 4,
            widget: 'button',
            class: 'btn-white',
            text: '<i class="fa fa-times"></i> Clear',
            event: 'clear'
          }
        ],
        [
          {
            width: 5,
            widget: 'date',
            name: 'ends_from',
            placeholder: 'Ends from...'
          },
          {
            width: 5,
            widget: 'date',
            name: 'ends_to',
            placeholder: 'Ends to...'
          },
          {
            width: 5,
            widget: 'select',
            name: 'portal_id',
            options: this.portals.map(portal => ({value: portal.id, label: portal.attributes.name})),
            nullable: true,
            placeholder: 'Choose Portal...'
          },
          {
            width: 5,
            widget: 'select',
            name: 'user_id',
            options: this.users.map(user => ({value: user.id, label: user.attributes.full_name})),
            nullable: true,
            placeholder: 'Choose User...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  }
}
</script>
